import { jsx } from "@ecopages/jsx/jsx-runtime";
import { cx } from "@/lib/cx";
import "./navigation-menu.script";
import { RuiButton } from "../button/button";
export function RuiNavigationMenuBar({
  children,
  class: className,
  ...props
}) {
  return /* @__PURE__ */jsx("div", {
    ...props,
    "data-ref": "bar",
    class: cx("rui-navigation-menu__bar", className),
    children
  });
}
export function RuiNavigationMenuPanels({
  children,
  class: className,
  ...props
}) {
  return /* @__PURE__ */jsx("div", {
    ...props,
    "data-ref": "panels",
    class: cx("rui-navigation-menu__panels", className),
    children
  });
}
export function RuiNavigationMenu({
  children,
  label,
  ...props
}) {
  return /* @__PURE__ */jsx("rui-navigation-menu", {
    ...props,
    label,
    children: /* @__PURE__ */jsx("nav", {
      class: "rui-navigation-menu",
      "data-ref": "root",
      "aria-label": label || void 0,
      children
    })
  });
}
export function RuiNavigationMenuTrigger({
  children,
  value,
  variant = "ghost",
  class: className,
  ...props
}) {
  return /* @__PURE__ */jsx(RuiButton, {
    ...props,
    variant,
    class: className,
    "data-navigation-item": true,
    "data-navigation-trigger": true,
    "data-value": value,
    children
  });
}
export function RuiNavigationMenuLink({
  children,
  href,
  class: className,
  ...props
}) {
  return /* @__PURE__ */jsx("a", {
    ...props,
    href,
    "data-navigation-item": true,
    class: cx("rui-button", "rui-button--ghost", "rui-button--md", className),
    children
  });
}
export function RuiNavigationMenuPanel({
  children,
  value,
  class: className,
  ...props
}) {
  return /* @__PURE__ */jsx("div", {
    ...props,
    class: className,
    "data-navigation-panel": true,
    "data-value": value,
    children
  });
}